import { Injectable, Injector, StaticProvider } from '@angular/core';

import { GRAPH_NODE_BUILDER_TOKEN } from './graph-node-builder.token';
import { AbstractGraphBuilder } from './model/abstract-graph-builder';
import { GraphNodeBuilder } from './model/graph-builder.types';

/**
 * Used to build graph nodes from definitions.
 *
 * It will use the `GraphNodeBuilder`s injected using the
 * `GRAPH_NODE_BUILDER_TOKEN` token.
 */
@Injectable()
export class GraphBuilder extends AbstractGraphBuilder {
  constructor(private injector: Injector) {
    super();
  }

  private _chain?: GraphNodeBuilder[];

  /**
   * Chain of graph node builders.
   */
  public get chain(): GraphNodeBuilder[] {
    if (!this._chain) {
      // Initialize chain from injector
      this._chain = this.injector.get(GRAPH_NODE_BUILDER_TOKEN, []);
    }

    return this._chain;
  }

  getInjector(providers: StaticProvider[]): Injector {
    return Injector.create({
      providers,
      parent: this.injector,
    });
  }
}
